<template>
  <v-container class="text-center pt-5" justify="center" align="center">
    <!-- logo -->
    <v-row>
      <v-col>
        <img alt="Logo" src="../assets/img/logo.png" />
      </v-col>
    </v-row>

    <!-- titulo -->
    <v-row>
      <v-col>
        <h1 class="text-h2">Sistema</h1>
      </v-col>
    </v-row>

    <!-- descripcion -->
    <v-row>
      <v-col>
        <h2
          class="text-subtitle-1"
        >Este es el subtitulo del sistema que puede ser corto o puede ser largo depende como lo veas</h2>
      </v-col>
    </v-row>

    <!-- ejemplos botones / numericas -->
    <v-row>
      <v-col v-for="i in [1,2,3,4]" cols="12" sm="6" md="3" :key="i">
        <v-card color="primary" dark>
          <v-card-title class="headline mb-3">Numérica #{{i}}</v-card-title>
          <v-card-subtitle
            class="text-left"
          >Esto es un ejemlpo de que se pueden poner cosas en la pantalla principal para dar informacion ni bien entras</v-card-subtitle>
          <v-card-actions>
            <v-btn text>Ver detalle</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col></v-col>
      <v-col></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
